import useModal from "@rf/base/modal/useModal";

import {
  DropPropertyTemplateModal,
  IDropPropertyTemplateModalData
} from "./components/DropPropertyTemplateModal";
const useDropProperty = () => {
  const { modal } = useModal();
  const handleDropProperty = (arg: IDropPropertyTemplateModalData) => {
    modal({
      template: <DropPropertyTemplateModal />,
      data: arg,
      options: {
        title: "Dar de baja",

        size: {
          xs: {
            width: "100%",
            height: "100%"
          },
          sm: {
            width: "60vw",
            minHeight: "300px"
          },
          md: {
            width: "60vw",
            minHeight: "300px"
          },
          lg: {
            width: "60vw",
            minHeight: "300px"
          },
          xl: {
            width: "60vw",
            minHeight: "300px"
          }
        }
      }
    });
  };

  return {
    handleDropProperty
  };
};

export default useDropProperty;
